import { logoutClearStorage } from "@/utils/storage";
import { history } from "@umijs/max";
import { stringify } from "querystring";
import { PAGES } from "@/constant/pages";

export const navLogin = (): void => {
  // 都要跳转登录了，那做一些清理工作，清除token和当前登录用户信息
  logoutClearStorage();
  const urlParams = new URL(window.location.href);
  const { search, pathname } = urlParams;
  console.log("---navLogin", search, pathname);
  /** 此方法会跳转到 redirect 参数所在的位置 */
  const redirect = urlParams.searchParams.get("redirect");
  // 通用方法，如果已经是登录页或者授权页，就不要跳转了
  if ([PAGES.USER_LOGIN, PAGES.CONNECT].includes(pathname as PAGES)) {
    return;
  }
  // Note: There may be security issues, please note
  if (pathname !== PAGES.USER_LOGIN && !redirect) {
    history.replace({
      pathname: PAGES.USER_LOGIN,
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};
